export const MERCHANT_ORDER_EXPORT_MAX_DATE_RANGE: number = 62;
